import gql from "graphql-tag";

export const MY_TIMESHEET_REMOVE_TIMESHEET = gql`
  mutation removeMysheetTimesheet($_id: String!) {
    removeMysheetTimesheet(_id: $_id)
  }
`;
